import envVar from '../config/envVars';
import httpGet from './httpClient/httpGet';
import httpPut from './httpClient/httpPut';
import {
  cloneFilter,
  SchoolDeclarationType,
  TemplateFileFilter,
  UploadDeclarationFileFilter
} from '../modules/DeclarationSetup/types';
import httpDelete from './httpClient/httpDelete';
import httpPost from './httpClient/httpPost';
import axios from 'axios';

const fetchDeclarationSetupData = async (
  school: string,
  academicYear: string
) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/schools/${school}/academic-year/${academicYear}/declarations`;
  const result = await httpGet(url);
  console.log('result', result);
  return result;
};

const addDeclarationForGrade = async (
  schoolDeclaration: SchoolDeclarationType
) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/schools/declarations`;
  return httpPut(url, schoolDeclaration);
};

const deleteDeclarationForGrade = async (id: string) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/schools/declarations/${id}`;
  return httpDelete(url);
};

const updateDeclarationItem = async (
  schoolDeclaration: SchoolDeclarationType
) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/schools/declarations`;
  return httpPut(url, schoolDeclaration);
};

const uploadDeclarationFile = async ({
  school,
  academicYear,
  grade,
  file
}: UploadDeclarationFileFilter) => {
  const formData = new FormData();
  formData.append('file', file);
  const data = Object.fromEntries(formData.entries());
  const url = `${envVar.REACT_APP_BASE_API_URL}/schools/${school}/academic-year/${academicYear}/grade/${grade}/upload-declarations`;
  return httpPost(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const getDeclarationTemplateVariables = async () => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/declarations/template-variables`;
  return httpGet(url);
};

const getDeclarationHtml = async ({
  school,
  academicYear,
  templateFileName
}: TemplateFileFilter) => {
  const baseUrl = envVar.REACT_APP_S3_BASE_URL;
  const url = `${baseUrl}/${school}/${academicYear}/declarations/${templateFileName}`;
  const cleanAxios = axios.create({
    headers: {}
  });
  return cleanAxios.get(url, {
    responseType: 'text'
  });
};

const cloneDeclarations = async (
  school: string,
  cloneFrom: cloneFilter,
  cloneTo: cloneFilter
) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/schools/${school}/clone-declarations`;
  return httpPost(url, { cloneFrom, cloneTo });
};

export {
  fetchDeclarationSetupData,
  getDeclarationHtml,
  addDeclarationForGrade,
  deleteDeclarationForGrade,
  updateDeclarationItem,
  uploadDeclarationFile,
  getDeclarationTemplateVariables,
  cloneDeclarations
};
